/**
 * Generated file, do not edit directly!
 */

/** @public */
const customPropertiesUnified = {
  /** Use as the default border style. */
  '--dt-borders-style-default': 'solid',
  /** Use to indicate interactive text. */
  '--dt-borders-style-dashed': 'dashed',
  /** Use as the default border width. */
  '--dt-borders-width-default': '1px',
  /** Use to emphasize borders. This can be useful to clearly separate content. */
  '--dt-borders-width-emphasized': '2px',
  /** Use as the subdued border radius for surfaces. */
  '--dt-borders-radius-surface-subdued': '9px',
  /** Use as the default border radius for surfaces. */
  '--dt-borders-radius-surface-default': '12px',
  /** Use as the subdued border radius for containers. */
  '--dt-borders-radius-container-subdued': '6px',
  /** Use as the default border radius for containers. */
  '--dt-borders-radius-container-default': '9px',
  /** Use as the subdued border radius for fields. */
  '--dt-borders-radius-field-subdued': '3px',
  /** Use as the default border radius for fields. */
  '--dt-borders-radius-field-default': '6px',
  /** Use for rounded or pill-like shapes. */
  '--dt-borders-radius-field-emphasized': '9999px',
  /** Use as the default level of elevation. */
  '--dt-box-shadows-surface-flat-rest': '0px 0px 0px 1px #2d2e4e0d',
  /** Use as the default level of elevation when a user's pointer is over an interactive surface. */
  '--dt-box-shadows-surface-flat-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  /** Use as the default level of elevation when the user is pressing an interactive surface. */
  '--dt-box-shadows-surface-flat-active': '0px 0px 0px 1px #2d2e4e0d',
  /** Use as the default level of elevation when moving a surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-flat-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  /** Use for raised surfaces. */
  '--dt-box-shadows-surface-raised-rest':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  /** Use when a user's pointer is over an interactive raised surface. */
  '--dt-box-shadows-surface-raised-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  /** Use when the user is pressing an interactive raised surface. */
  '--dt-box-shadows-surface-raised-active':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 4px 8px -2px #2d2e4e12',
  /** Use when moving a raised surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-raised-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  /** Use for floating surfaces. */
  '--dt-box-shadows-surface-floating-rest':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  /** Use when a user's pointer is over an interactive floating surface. */
  '--dt-box-shadows-surface-floating-hover':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 6px 14px -2px #2d2e4e3d',
  /** Use when the user is pressing an interactive floating surface. */
  '--dt-box-shadows-surface-floating-active':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 5px 11px -2px #2d2e4e29',
  /** Use when moving a floating surface, on drag-and-drop interaction. */
  '--dt-box-shadows-surface-floating-drag':
    '0px 0px 0px 1px #2d2e4e08, 0px 1px 2px #2d2e4e0d, 0px 7px 17px -2px #2d2e4e52',
  /** Use for emphasized neutral button and input in rest state. */
  '--dt-box-shadows-field-neutral-emphasized-rest':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #fff',
  /** Use for emphasized neutral button and input in hover state. */
  '--dt-box-shadows-field-neutral-emphasized-hover':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #dadbe4',
  /** Use for emphasized neutral button and input in active state. */
  '--dt-box-shadows-field-neutral-emphasized-active':
    'inset 0px 0px 0px 1px #2f2f4f1f, inset 0px -1px 0px #2f2f4f14, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d0d1dc',
  /** Use for accentuated neutral button. */
  '--dt-box-shadows-field-neutral-accent':
    'inset 0px 0px 0px 1px #0000004d, inset 0px -1px 0px #0000008c, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for disabled neutral button and input. */
  '--dt-box-shadows-field-neutral-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for emphasized primary button in rest state. */
  '--dt-box-shadows-field-primary-emphasized-rest':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e1e5f7',
  /** Use for emphasized primary button in hover state. */
  '--dt-box-shadows-field-primary-emphasized-hover':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d5dbf6',
  /** Use for emphasized primary button in active state. */
  '--dt-box-shadows-field-primary-emphasized-active':
    'inset 0px 0px 0px 1px #250f980f, inset 0px -1px 0px #250f981a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c9d1f4',
  /** Use for accentuated primary button. */
  '--dt-box-shadows-field-primary-accent':
    'inset 0px 0px 0px 1px #250f9833, inset 0px -1px 0px #250f984d, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for disabled primary button. */
  '--dt-box-shadows-field-primary-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for emphasized success button in rest state. */
  '--dt-box-shadows-field-success-emphasized-rest':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #e0e7e6',
  /** Use for emphasized success button in hover state. */
  '--dt-box-shadows-field-success-emphasized-hover':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #d3dedd',
  /** Use for emphasized success button in active state. */
  '--dt-box-shadows-field-success-emphasized-active':
    'inset 0px 0px 0px 1px #003b360f, inset 0px -1px 0px #003b361a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #c7d5d3',
  /** Use for accentuated success button. */
  '--dt-box-shadows-field-success-accent':
    'inset 0px 0px 0px 1px #003b3626, inset 0px -1px 0px #003b364d, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for disabled success button. */
  '--dt-box-shadows-field-success-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for emphasized warning button in rest state. */
  '--dt-box-shadows-field-warning-emphasized-rest':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9f0e5',
  /** Use for emphasized warning button in hover state. */
  '--dt-box-shadows-field-warning-emphasized-hover':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9ebdb',
  /** Use for emphasized warning button in active state. */
  '--dt-box-shadows-field-warning-emphasized-active':
    'inset 0px 0px 0px 1px #512a000f, inset 0px -1px 0px #512a001a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f9e6d0',
  /** Use for accentuated warning button. */
  '--dt-box-shadows-field-warning-accent':
    'inset 0px 0px 0px 1px #512a001a, inset 0px -1px 0px #512a0033, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for disabled warning button. */
  '--dt-box-shadows-field-warning-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for emphasized critical button and input in rest state. */
  '--dt-box-shadows-field-critical-emphasized-rest':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f8e1e1',
  /** Use for emphasized critical button and input in hover state. */
  '--dt-box-shadows-field-critical-emphasized-hover':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f6d6d5',
  /** Use for emphasized critical button and input in active state. */
  '--dt-box-shadows-field-critical-emphasized-active':
    'inset 0px 0px 0px 1px #7500130f, inset 0px -1px 0px #7500131a, 0px 1px 1px -1px #2d2e4e1f, inset 0px 0px 0px 1px #f5cac9',
  /** Use for accentuated critical button. */
  '--dt-box-shadows-field-critical-accent':
    'inset 0px 0px 0px 1px #75001333, inset 0px -1px 0px #7500134d, 0px 1px 1px -1px #2d2e4e1f',
  /** Use for disabled critical button and input. */
  '--dt-box-shadows-field-critical-disabled':
    'inset 0px 0px 0px 1px #2f2f4f0f, inset 0px -1px 0px #2f2f4f0a, 0px 1px 1px -1px #2d2e4e1f',
  /** Use with `@media` `max-width` to apply styles to mobile-sized screens. */
  '--dt-breakpoints-max-mobile': '640px',
  /** Use with `@media` `max-width` to apply styles to tablets and smaller screens. */
  '--dt-breakpoints-max-tablet': '960px',
  /** Use with `@media` `max-width` to apply styles to desktops and smaller screens. */
  '--dt-breakpoints-max-desktop': '1920px',
  /** Use this with `@media` `min-width`, to apply styles to tablet and wider screen sizes. */
  '--dt-breakpoints-min-tablet': '641px',
  /** Use this with `@media` `min-width`, to apply styles to desktop and wider screen sizes. */
  '--dt-breakpoints-min-desktop': '961px',
  /** Use this with `@media` `min-width`, to apply styles to widescreen desktop and wider screen sizes. */
  '--dt-breakpoints-min-widescreen': '1921px',
  '--dt-colors-theme-foreground-10': '#2d2e4e',
  '--dt-colors-theme-foreground-20': '#fff',
  '--dt-colors-theme-background-10': '#f9f9fa',
  '--dt-colors-theme-background-20': '#fff',
  '--dt-colors-theme-background-shell-default': '#f2f2f5',
  '--dt-colors-theme-background-surface-backdrop-embedded': '#f9f9facc',
  '--dt-colors-theme-neutral-10': '#f2f2f5',
  '--dt-colors-theme-neutral-20': '#ebecf0',
  '--dt-colors-theme-neutral-30': '#e4e5eb',
  '--dt-colors-theme-neutral-40': '#dadbe4',
  '--dt-colors-theme-neutral-50': '#d0d1dc',
  '--dt-colors-theme-neutral-60': '#c6c7d5',
  '--dt-colors-theme-neutral-70': '#5b5c81',
  '--dt-colors-theme-neutral-80': '#4d4e72',
  '--dt-colors-theme-neutral-90': '#404164',
  '--dt-colors-theme-primary-10': '#f1f2f9',
  '--dt-colors-theme-primary-20': '#e9ecf8',
  '--dt-colors-theme-primary-30': '#e1e5f7',
  '--dt-colors-theme-primary-40': '#d5dbf6',
  '--dt-colors-theme-primary-50': '#c9d1f4',
  '--dt-colors-theme-primary-60': '#bdc7f2',
  '--dt-colors-theme-primary-70': '#474fcf',
  '--dt-colors-theme-primary-80': '#3b3fbe',
  '--dt-colors-theme-primary-90': '#312dad',
  '--dt-colors-theme-success-10': '#f1f3f3',
  '--dt-colors-theme-success-20': '#e8eded',
  '--dt-colors-theme-success-30': '#e0e7e6',
  '--dt-colors-theme-success-40': '#d3dedd',
  '--dt-colors-theme-success-50': '#c7d5d3',
  '--dt-colors-theme-success-60': '#bbccc9',
  '--dt-colors-theme-success-70': '#2f6862',
  '--dt-colors-theme-success-80': '#1f5a54',
  '--dt-colors-theme-success-90': '#0d4c47',
  '--dt-colors-theme-warning-10': '#f9f6f3',
  '--dt-colors-theme-warning-20': '#f9f3ec',
  '--dt-colors-theme-warning-30': '#f9f0e5',
  '--dt-colors-theme-warning-40': '#f9ebdb',
  '--dt-colors-theme-warning-50': '#f9e6d0',
  '--dt-colors-theme-warning-60': '#f9e1c6',
  '--dt-colors-theme-warning-70': '#eea53c',
  '--dt-colors-theme-warning-80': '#ffb54f',
  '--dt-colors-theme-warning-90': '#ffc76d',
  '--dt-colors-theme-critical-10': '#f9f1f2',
  '--dt-colors-theme-critical-20': '#f8e9e9',
  '--dt-colors-theme-critical-30': '#f8e1e1',
  '--dt-colors-theme-critical-40': '#f6d6d5',
  '--dt-colors-theme-critical-50': '#f5cac9',
  '--dt-colors-theme-critical-60': '#f3bebd',
  '--dt-colors-theme-critical-70': '#c62239',
  '--dt-colors-theme-critical-80': '#b4002b',
  '--dt-colors-theme-critical-90': '#a2001d',
  /** Use for the background of your app. */
  '--dt-colors-background-base-default': '#f9f9fa',
  /** Use as the backdrop for surfaces to reduce the visual noise of background elements. */
  '--dt-colors-background-surface-backdrop': '#f9f9facc',
  /** Use as the backdrop for embedded overlays to reduce the visual noise of background elements. */
  '--dt-colors-background-surface-backdrop-embedded': '#f9f9facc',
  /** Use for default surface background. */
  '--dt-colors-background-surface-default': '#fff',
  /** Use for subtle containers. */
  '--dt-colors-background-container-neutral-subdued': '#f9f9fa',
  /** Use for default containers. */
  '--dt-colors-background-container-neutral-default': '#f2f2f5',
  /** Use for emphasized neutral containers that draw attention. */
  '--dt-colors-background-container-neutral-emphasized': '#ebecf0',
  /** Use for accentuated neutral containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-neutral-accent': '#5b5c81',
  /** Use for default primary color containers. */
  '--dt-colors-background-container-primary-default': '#f1f2f9',
  /** Use for emphasized primary color containers that draw attention. */
  '--dt-colors-background-container-primary-emphasized': '#e9ecf8',
  /** Use for accentuated primary color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-primary-accent': '#474fcf',
  /** Use for default success color containers. */
  '--dt-colors-background-container-success-default': '#f1f3f3',
  /** Use for emphasized success color containers that draw attention. */
  '--dt-colors-background-container-success-emphasized': '#e8eded',
  /** Use for accentuated success color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-success-accent': '#2f6862',
  /** Use for default warning color containers. */
  '--dt-colors-background-container-warning-default': '#f9f6f3',
  /** Use for emphasized warning color containers that draw attention. */
  '--dt-colors-background-container-warning-emphasized': '#f9f3ec',
  /** Use for accentuated warning color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-warning-accent': '#eea53c',
  /** Use for default critical color containers. */
  '--dt-colors-background-container-critical-default': '#f9f1f2',
  /** Use for emphasized critical color containers that draw attention. */
  '--dt-colors-background-container-critical-emphasized': '#f8e9e9',
  /** Use for accentuated critical color containers with high contrast. Use sparingly. */
  '--dt-colors-background-container-critical-accent': '#c62239',
  /** Use for disabled neutral fields. */
  '--dt-colors-background-field-neutral-disabled': '#e4e5eb80',
  /** Use for default neutral fields. */
  '--dt-colors-background-field-neutral-default': '#e4e5eb00',
  /** Use for hover interaction on default neutral fields. */
  '--dt-colors-background-field-neutral-default-hover': '#dadbe4',
  /** Use for click interaction on default neutral fields. */
  '--dt-colors-background-field-neutral-default-active': '#d0d1dc',
  /** Use for emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized': '#e4e5eb',
  /** Use for hover interaction on emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized-hover': '#dadbe4',
  /** Use for click interaction on emphasized neutral fields. */
  '--dt-colors-background-field-neutral-emphasized-active': '#d0d1dc',
  /** Use for accentuated neutral fields. Use sparingly. */
  '--dt-colors-background-field-neutral-accent': '#5b5c81',
  /** Use for hover interaction on accentuated neutral fields. */
  '--dt-colors-background-field-neutral-accent-hover': '#4d4e72',
  /** Use for click interaction on accentuated neutral fields. */
  '--dt-colors-background-field-neutral-accent-active': '#404164',
  /** Use for disabled primary fields. */
  '--dt-colors-background-field-primary-disabled': '#e4e5eb80',
  /** Use for default primary fields. */
  '--dt-colors-background-field-primary-default': '#e1e5f700',
  /** Use for hover interaction on default primary fields. */
  '--dt-colors-background-field-primary-default-hover': '#d5dbf6',
  /** Use for click interaction on default primary fields. */
  '--dt-colors-background-field-primary-default-active': '#c9d1f4',
  /** Use for emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized': '#e1e5f7',
  /** Use for hover interaction on emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized-hover': '#d5dbf6',
  /** Use for click interaction on emphasized primary fields. */
  '--dt-colors-background-field-primary-emphasized-active': '#c9d1f4',
  /** Use for accentuated primary fields. Use sparingly. */
  '--dt-colors-background-field-primary-accent': '#474fcf',
  /** Use for hover interaction on accentuated primary fields. */
  '--dt-colors-background-field-primary-accent-hover': '#3b3fbe',
  /** Use for click interaction on accentuated primary fields. */
  '--dt-colors-background-field-primary-accent-active': '#312dad',
  /** Use for disabled success fields. */
  '--dt-colors-background-field-success-disabled': '#e4e5eb80',
  /** Use for default success fields. */
  '--dt-colors-background-field-success-default': '#e0e7e600',
  /** Use for hover interaction on default success fields. */
  '--dt-colors-background-field-success-default-hover': '#d3dedd',
  /** Use for click interaction on default success fields. */
  '--dt-colors-background-field-success-default-active': '#c7d5d3',
  /** Use for emphasized success fields. */
  '--dt-colors-background-field-success-emphasized': '#e0e7e6',
  /** Use for hover interaction on emphasized success fields. */
  '--dt-colors-background-field-success-emphasized-hover': '#d3dedd',
  /** Use for click interaction on emphasized success fields. */
  '--dt-colors-background-field-success-emphasized-active': '#c7d5d3',
  /** Use for accentuated success fields. Use sparingly. */
  '--dt-colors-background-field-success-accent': '#2f6862',
  /** Use for hover interaction on accentuated success fields. */
  '--dt-colors-background-field-success-accent-hover': '#1f5a54',
  /** Use for click interaction on accentuated success fields. */
  '--dt-colors-background-field-success-accent-active': '#0d4c47',
  /** Use for disabled warning fields. */
  '--dt-colors-background-field-warning-disabled': '#e4e5eb80',
  /** Use for default warning fields. */
  '--dt-colors-background-field-warning-default': '#f9f0e500',
  /** Use for hover interaction on default warning fields. */
  '--dt-colors-background-field-warning-default-hover': '#f9ebdb',
  /** Use for click interaction on default warning fields. */
  '--dt-colors-background-field-warning-default-active': '#f9e6d0',
  /** Use for emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized': '#f9f0e5',
  /** Use for hover interaction on emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized-hover': '#f9ebdb',
  /** Use for click interaction on emphasized warning fields. */
  '--dt-colors-background-field-warning-emphasized-active': '#f9e6d0',
  /** Use for accentuated warning fields. Use sparingly. */
  '--dt-colors-background-field-warning-accent': '#eea53c',
  /** Use for hover interaction on accentuated warning fields. */
  '--dt-colors-background-field-warning-accent-hover': '#ffb54f',
  /** Use for click interaction on accentuated warning fields. */
  '--dt-colors-background-field-warning-accent-active': '#ffc76d',
  /** Use for disabled critical fields. */
  '--dt-colors-background-field-critical-disabled': '#e4e5eb80',
  /** Use for default critical fields. */
  '--dt-colors-background-field-critical-default': '#f8e1e100',
  /** Use for hover interaction on default critical fields. */
  '--dt-colors-background-field-critical-default-hover': '#f6d6d5',
  /** Use for click interaction on default critical fields. */
  '--dt-colors-background-field-critical-default-active': '#f5cac9',
  /** Use for emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized': '#f8e1e1',
  /** Use for hover interaction on emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized-hover': '#f6d6d5',
  /** Use for click interaction on emphasized critical fields. */
  '--dt-colors-background-field-critical-emphasized-active': '#f5cac9',
  /** Use for accentuated critical fields. Use sparingly. */
  '--dt-colors-background-field-critical-accent': '#c62239',
  /** Use for hover interaction on accentuated critical fields. */
  '--dt-colors-background-field-critical-accent-hover': '#b4002b',
  /** Use for click interaction on accentuated critical fields. */
  '--dt-colors-background-field-critical-accent-active': '#a2001d',
  /** Use for the shell background. */
  '--dt-colors-background-shell-default': '#f2f2f5',
  /** Use as the color for drop-shadows. */
  '--dt-colors-box-shadow-default': '#2d2e4e',
  /** Use as the default border color in a disabled state. */
  '--dt-colors-border-neutral-disabled': '#dadbe480',
  /** Use as the default border color. */
  '--dt-colors-border-neutral-default': '#dadbe4',
  /** Use as default border color on hover interaction. */
  '--dt-colors-border-neutral-default-hover': '#d0d1dc',
  /** Use as default border color on click interaction. */
  '--dt-colors-border-neutral-default-active': '#c6c7d5',
  /** Use as the border color of accentuated elements. */
  '--dt-colors-border-neutral-accent': '#595a7d',
  /** Use as border color of accentuated elements on hover interaction. */
  '--dt-colors-border-neutral-accent-hover': '#434465',
  /** Use as border color of accentuated elements on click interaction. */
  '--dt-colors-border-neutral-accent-active': '#2f2f4f',
  /** Use as border color for disabled elements in accentuated context. */
  '--dt-colors-border-neutral-on-accent-disabled': '#f3f3f633',
  /** Use as border color for elements in accentuated context. */
  '--dt-colors-border-neutral-on-accent-default': '#f3f3f6',
  /** Use as border color for elements in accentuated context on hover interaction. */
  '--dt-colors-border-neutral-on-accent-default-hover': '#f3f3f6cc',
  /** Use as border color for elements in accentuated context on click interaction. */
  '--dt-colors-border-neutral-on-accent-default-active': '#f3f3f699',
  /** Use as border color of subtle elements. */
  '--dt-colors-border-neutral-subdued': '#e4e5eb',
  /** Use as border color of subtle elements on hover interaction. */
  '--dt-colors-border-neutral-subdued-hover': '#d0d1dc',
  /** Use for click interactions on subtle elements. */
  '--dt-colors-border-neutral-subdued-active': '#c6c7d5',
  /** Use as border primary color in a disabled state. */
  '--dt-colors-border-primary-disabled': '#dadbe480',
  /** Use as the default primary border color. */
  '--dt-colors-border-primary-default': '#d5dbf6',
  /** Use as default border primary color on hover interaction. */
  '--dt-colors-border-primary-default-hover': '#c9d1f4',
  /** Use as default border primary color on click interaction. */
  '--dt-colors-border-primary-default-active': '#bdc7f2',
  /** Use as the border color of primary accentuated elements. */
  '--dt-colors-border-primary-accent': '#464cce',
  /** Use as border color of primary accentuated elements on hover interaction. */
  '--dt-colors-border-primary-accent-hover': '#3431b3',
  /** Use as border color of primary accentuated elements on click interaction. */
  '--dt-colors-border-primary-accent-active': '#250f98',
  /** Use as border color for disabled elements in primary accentuated context. */
  '--dt-colors-border-primary-on-accent-disabled': '#f4f4fb33',
  /** Use as border color for elements in primary accentuated context. */
  '--dt-colors-border-primary-on-accent-default': '#f4f4fb',
  /** Use as border color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-border-primary-on-accent-default-hover': '#f4f4fbcc',
  /** Use as border color for elements in primary accentuated context on click interaction. */
  '--dt-colors-border-primary-on-accent-default-active': '#f4f4fb99',
  /** Use as border success color in a disabled state. */
  '--dt-colors-border-success-disabled': '#dadbe480',
  /** Use as the default success border color. */
  '--dt-colors-border-success-default': '#d3dedd',
  /** Use as default border success color on hover interaction. */
  '--dt-colors-border-success-default-hover': '#c7d5d3',
  /** Use as default border success color on click interaction. */
  '--dt-colors-border-success-default-active': '#bbccc9',
  /** Use as the border color of success accentuated elements. */
  '--dt-colors-border-success-accent': '#2d6761',
  /** Use as border color of success accentuated elements on hover interaction. */
  '--dt-colors-border-success-accent-hover': '#12504b',
  /** Use as border color of success accentuated elements on click interaction. */
  '--dt-colors-border-success-accent-active': '#003b36',
  /** Use as border color for disabled elements in success accentuated context. */
  '--dt-colors-border-success-on-accent-disabled': '#f1f4f433',
  /** Use as border color for elements in success accentuated context. */
  '--dt-colors-border-success-on-accent-default': '#f1f4f4',
  /** Use as border color for elements in success accentuated context on hover interaction. */
  '--dt-colors-border-success-on-accent-default-hover': '#f1f4f4cc',
  /** Use as border color for elements in success accentuated context on click interaction. */
  '--dt-colors-border-success-on-accent-default-active': '#f1f4f499',
  /** Use as border warning color in a disabled state. */
  '--dt-colors-border-warning-disabled': '#dadbe480',
  /** Use as the default warning border color. */
  '--dt-colors-border-warning-default': '#f9ebdb',
  /** Use as default border warning color on hover interaction. */
  '--dt-colors-border-warning-default-hover': '#f9e6d0',
  /** Use as default border warning color on click interaction. */
  '--dt-colors-border-warning-default-active': '#f9e1c6',
  /** Use as the border color of warning accentuated elements. */
  '--dt-colors-border-warning-accent': '#855400',
  /** Use as border color of warning accentuated elements on hover interaction. */
  '--dt-colors-border-warning-accent-hover': '#6d3d00',
  /** Use as border color of warning accentuated elements on click interaction. */
  '--dt-colors-border-warning-accent-active': '#512a00',
  /** Use as border color for disabled elements in warning accentuated context. */
  '--dt-colors-border-warning-on-accent-disabled': '#27202433',
  /** Use as border color for elements in warning accentuated context. */
  '--dt-colors-border-warning-on-accent-default': '#272024',
  /** Use as border color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-border-warning-on-accent-default-hover': '#272024cc',
  /** Use as border color for elements in warning accentuated context on click interaction. */
  '--dt-colors-border-warning-on-accent-default-active': '#27202499',
  /** Use as border critical color in a disabled state. */
  '--dt-colors-border-critical-disabled': '#dadbe480',
  /** Use as the default critical border color. */
  '--dt-colors-border-critical-default': '#f6d6d5',
  /** Use as default border critical color on hover interaction. */
  '--dt-colors-border-critical-default-hover': '#f5cac9',
  /** Use as default border critical color on click interaction. */
  '--dt-colors-border-critical-default-active': '#f3bebd',
  /** Use as the border color of critical accentuated elements. */
  '--dt-colors-border-critical-accent': '#bb0731',
  /** Use as border color of critical accentuated elements on hover interaction. */
  '--dt-colors-border-critical-accent-hover': '#9b001e',
  /** Use as border color of critical accentuated elements on click interaction. */
  '--dt-colors-border-critical-accent-active': '#750013',
  /** Use as border color for disabled elements in critical accentuated context. */
  '--dt-colors-border-critical-on-accent-disabled': '#f9f1f333',
  /** Use as border color for elements in critical accentuated context. */
  '--dt-colors-border-critical-on-accent-default': '#f9f1f3',
  /** Use as border color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-border-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as border color for elements in critical accentuated context on click interaction. */
  '--dt-colors-border-critical-on-accent-default-active': '#f9f1f399',
  /** Use for text color on disabled state. */
  '--dt-colors-text-neutral-disabled': '#595a7d80',
  /** Use for subtle, understated text color. */
  '--dt-colors-text-neutral-subdued': '#595a7d',
  /** Use for subtle, understated text color on hover interaction. */
  '--dt-colors-text-neutral-subdued-hover': '#434465',
  /** Use for subtle, understated text color on click interaction. */
  '--dt-colors-text-neutral-subdued-active': '#2f2f4f',
  /** Use as the default text color. */
  '--dt-colors-text-neutral-default': '#2f2f4f',
  /** Use as the default text color on hover interaction. */
  '--dt-colors-text-neutral-default-hover': '#434465',
  /** Use as the default text color on click interaction. */
  '--dt-colors-text-neutral-default-active': '#595a7d',
  /** Use as text color for disabled elements in accentuated context. */
  '--dt-colors-text-neutral-on-accent-disabled': '#f3f3f680',
  /** Use as text color for elements in accentuated context. */
  '--dt-colors-text-neutral-on-accent-default': '#f3f3f6',
  /** Use as text color for elements in accentuated context on hover interaction. */
  '--dt-colors-text-neutral-on-accent-default-hover': '#f3f3f6cc',
  /** Use as text color for elements in accentuated context on click interaction. */
  '--dt-colors-text-neutral-on-accent-default-active': '#f3f3f699',
  /** Use for primary text color on disabled state. */
  '--dt-colors-text-primary-disabled': '#595a7d80',
  /** Use as the default primary text color. */
  '--dt-colors-text-primary-default': '#464cce',
  /** Use as the default primary text color on hover interaction. */
  '--dt-colors-text-primary-default-hover': '#3431b3',
  /** Use as the default primary text color on click interaction. */
  '--dt-colors-text-primary-default-active': '#250f98',
  /** Use as text color for disabled elements in primary accentuated context. */
  '--dt-colors-text-primary-on-accent-disabled': '#f4f4fb80',
  /** Use as text color for elements in primary accentuated context. */
  '--dt-colors-text-primary-on-accent-default': '#f4f4fb',
  /** Use as text color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-text-primary-on-accent-default-hover': '#f4f4fbcc',
  /** Use as text color for elements in primary accentuated context on click interaction. */
  '--dt-colors-text-primary-on-accent-default-active': '#f4f4fb99',
  /** Use for success text color on disabled state. */
  '--dt-colors-text-success-disabled': '#595a7d80',
  /** Use as the default success text color. */
  '--dt-colors-text-success-default': '#2d6761',
  /** Use as the default success text color on hover interaction. */
  '--dt-colors-text-success-default-hover': '#12504b',
  /** Use as the default success text color on click interaction. */
  '--dt-colors-text-success-default-active': '#003b36',
  /** Use as text color for disabled elements in success accentuated context. */
  '--dt-colors-text-success-on-accent-disabled': '#f1f4f480',
  /** Use as text color for elements in success accentuated context. */
  '--dt-colors-text-success-on-accent-default': '#f1f4f4',
  /** Use as text color for elements in success accentuated context on hover interaction. */
  '--dt-colors-text-success-on-accent-default-hover': '#f1f4f4cc',
  /** Use as text color for elements in success accentuated context on click interaction. */
  '--dt-colors-text-success-on-accent-default-active': '#f1f4f499',
  /** Use for warning text color on disabled state. */
  '--dt-colors-text-warning-disabled': '#595a7d80',
  /** Use as the default warning text color. */
  '--dt-colors-text-warning-default': '#855400',
  /** Use as the default warning text color on hover interaction. */
  '--dt-colors-text-warning-default-hover': '#6d3d00',
  /** Use as the default warning text color on click interaction. */
  '--dt-colors-text-warning-default-active': '#512a00',
  /** Use as text color for disabled elements in warning accentuated context. */
  '--dt-colors-text-warning-on-accent-disabled': '#27202480',
  /** Use as text color for elements in warning accentuated context. */
  '--dt-colors-text-warning-on-accent-default': '#272024',
  /** Use as text color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-text-warning-on-accent-default-hover': '#272024cc',
  /** Use as text color for elements in warning accentuated context on click interaction. */
  '--dt-colors-text-warning-on-accent-default-active': '#27202499',
  /** Use for critical text color on disabled state. */
  '--dt-colors-text-critical-disabled': '#595a7d80',
  /** Use as the default critical text color. */
  '--dt-colors-text-critical-default': '#bb0731',
  /** Use as the default critical text color on hover interaction. */
  '--dt-colors-text-critical-default-hover': '#9b001e',
  /** Use as the default critical text color on click interaction. */
  '--dt-colors-text-critical-default-active': '#750013',
  /** Use as text color for disabled elements in critical accentuated context. */
  '--dt-colors-text-critical-on-accent-disabled': '#f9f1f380',
  /** Use as text color for elements in critical accentuated context. */
  '--dt-colors-text-critical-on-accent-default': '#f9f1f3',
  /** Use as text color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-text-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as text color for elements in critical accentuated context on click interaction. */
  '--dt-colors-text-critical-on-accent-default-active': '#f9f1f399',
  /** Use for icon color on disabled state. */
  '--dt-colors-icon-neutral-disabled': '#595a7d80',
  /** Use for subtle, understated icon color. */
  '--dt-colors-icon-neutral-subdued': '#595a7d',
  /** Use for subtle, understated icon color on hover interaction. */
  '--dt-colors-icon-neutral-subdued-hover': '#434465',
  /** Use for subtle, understated icon color on click interaction. */
  '--dt-colors-icon-neutral-subdued-active': '#2f2f4f',
  /** Use as the default icon color. */
  '--dt-colors-icon-neutral-default': '#2f2f4f',
  /** Use as the default icon color on hover interaction. */
  '--dt-colors-icon-neutral-default-hover': '#434465',
  /** Use as the default icon color on click interaction. */
  '--dt-colors-icon-neutral-default-active': '#595a7d',
  /** Use as icon color for disabled elements in accentuated context. */
  '--dt-colors-icon-neutral-on-accent-disabled': '#f3f3f680',
  /** Use as icon color for elements in accentuated context. */
  '--dt-colors-icon-neutral-on-accent-default': '#f3f3f6',
  /** Use as icon color for elements in accentuated context on hover interaction. */
  '--dt-colors-icon-neutral-on-accent-default-hover': '#f3f3f6cc',
  /** Use as icon color for elements in accentuated context on click interaction. */
  '--dt-colors-icon-neutral-on-accent-default-active': '#f3f3f699',
  /** Use for primary icon color on disabled state. */
  '--dt-colors-icon-primary-disabled': '#595a7d80',
  /** Use as the default primary icon color. */
  '--dt-colors-icon-primary-default': '#464cce',
  /** Use as the default primary icon color on hover interaction. */
  '--dt-colors-icon-primary-default-hover': '#3431b3',
  /** Use as the default primary icon color on click interaction. */
  '--dt-colors-icon-primary-default-active': '#250f98',
  /** Use as icon color for disabled elements in primary accentuated context. */
  '--dt-colors-icon-primary-on-accent-disabled': '#f4f4fb80',
  /** Use as icon color for elements in primary accentuated context. */
  '--dt-colors-icon-primary-on-accent-default': '#f4f4fb',
  /** Use as icon color for elements in primary accentuated context on hover interaction. */
  '--dt-colors-icon-primary-on-accent-default-hover': '#f4f4fbcc',
  /** Use as icon color for elements in primary accentuated context on click interaction. */
  '--dt-colors-icon-primary-on-accent-default-active': '#f4f4fb99',
  /** Use for success icon color on disabled state. */
  '--dt-colors-icon-success-disabled': '#595a7d80',
  /** Use as the default success icon color. */
  '--dt-colors-icon-success-default': '#2d6761',
  /** Use as the default success icon color on hover interaction. */
  '--dt-colors-icon-success-default-hover': '#12504b',
  /** Use as the default success icon color on click interaction. */
  '--dt-colors-icon-success-default-active': '#003b36',
  /** Use as icon color for disabled elements in success accentuated context. */
  '--dt-colors-icon-success-on-accent-disabled': '#f1f4f480',
  /** Use as icon color for elements in success accentuated context. */
  '--dt-colors-icon-success-on-accent-default': '#f1f4f4',
  /** Use as icon color for elements in success accentuated context on hover interaction. */
  '--dt-colors-icon-success-on-accent-default-hover': '#f1f4f4cc',
  /** Use as icon color for elements in success accentuated context on click interaction. */
  '--dt-colors-icon-success-on-accent-default-active': '#f1f4f499',
  /** Use for warning icon color on disabled state. */
  '--dt-colors-icon-warning-disabled': '#595a7d80',
  /** Use as the default warning icon color. */
  '--dt-colors-icon-warning-default': '#855400',
  /** Use as the default warning icon color on hover interaction. */
  '--dt-colors-icon-warning-default-hover': '#6d3d00',
  /** Use as the default warning icon color on click interaction. */
  '--dt-colors-icon-warning-default-active': '#512a00',
  /** Use as icon color for disabled elements in warning accentuated context. */
  '--dt-colors-icon-warning-on-accent-disabled': '#27202480',
  /** Use as icon color for elements in warning accentuated context. */
  '--dt-colors-icon-warning-on-accent-default': '#272024',
  /** Use as icon color for elements in warning accentuated context on hover interaction. */
  '--dt-colors-icon-warning-on-accent-default-hover': '#272024cc',
  /** Use as icon color for elements in warning accentuated context on click interaction. */
  '--dt-colors-icon-warning-on-accent-default-active': '#27202499',
  /** Use for critical icon color on disabled state. */
  '--dt-colors-icon-critical-disabled': '#595a7d80',
  /** Use as the default critical icon color. */
  '--dt-colors-icon-critical-default': '#bb0731',
  /** Use as the default critical icon color on hover interaction. */
  '--dt-colors-icon-critical-default-hover': '#9b001e',
  /** Use as the default critical icon color on click interaction. */
  '--dt-colors-icon-critical-default-active': '#750013',
  /** Use as icon color for disabled elements in critical accentuated context. */
  '--dt-colors-icon-critical-on-accent-disabled': '#f9f1f380',
  /** Use as icon color for elements in critical accentuated context. */
  '--dt-colors-icon-critical-on-accent-default': '#f9f1f3',
  /** Use as icon color for elements in critical accentuated context on hover interaction. */
  '--dt-colors-icon-critical-on-accent-default-hover': '#f9f1f3cc',
  /** Use as icon color for elements in critical accentuated context on click interaction. */
  '--dt-colors-icon-critical-on-accent-default-active': '#f9f1f399',
  /** Use to style 'Comment' syntax on a code editor context. */
  '--dt-colors-syntax-comment': '#545586',
  /** Use to style 'String' syntax on a code editor context. */
  '--dt-colors-syntax-string': '#086467',
  /** Use to style 'Variable' syntax on a code editor context. */
  '--dt-colors-syntax-variable': '#2754b5',
  /** Use to style 'Number' syntax on a code editor context. */
  '--dt-colors-syntax-number': '#aa0081',
  /** Use to style 'Punctuation' syntax on a code editor context. */
  '--dt-colors-syntax-punctuation': '#8136a9',
  /** Use to style 'Function' syntax on a code editor context. */
  '--dt-colors-syntax-function': '#2754b5',
  /** Use to style 'Classname' syntax on a code editor context. */
  '--dt-colors-syntax-classname': '#2c2d4d',
  /** Use to style 'Tag' syntax on a code editor context. */
  '--dt-colors-syntax-tag': '#b30926',
  /** Use to style 'Operators' syntax on a code editor context. */
  '--dt-colors-syntax-operators': '#8136a9',
  /** Use to style 'Boolean' syntax on a code editor context. */
  '--dt-colors-syntax-boolean': '#973f00',
  '--dt-colors-charts-categorical-color-01-default': '#0057bf',
  '--dt-colors-charts-categorical-color-02-default': '#36383a',
  '--dt-colors-charts-categorical-color-03-default': '#008758',
  '--dt-colors-charts-categorical-color-04-default': '#eb009b',
  '--dt-colors-charts-categorical-color-05-default': '#82878b',
  '--dt-colors-charts-categorical-color-06-default': '#af7e00',
  '--dt-colors-charts-categorical-color-07-default': '#0098a5',
  '--dt-colors-charts-categorical-color-08-default': '#8e5fff',
  '--dt-colors-charts-categorical-color-09-default': '#409f00',
  '--dt-colors-charts-categorical-color-10-default': '#844e2f',
  '--dt-colors-charts-categorical-color-11-default': '#2380ff',
  '--dt-colors-charts-categorical-color-12-default': '#d40036',
  '--dt-colors-charts-categorical-color-13-default': '#205900',
  '--dt-colors-charts-categorical-color-14-default': '#d55d00',
  '--dt-colors-charts-categorical-color-15-default': '#5600b8',
  '--dt-colors-charts-categorical-vivid-color-01-default': '#00b3c3',
  '--dt-colors-charts-categorical-vivid-color-02-default': '#7f2eff',
  '--dt-colors-charts-categorical-vivid-color-03-default': '#fa676e',
  '--dt-colors-charts-categorical-vivid-color-04-default': '#d7b43b',
  '--dt-colors-charts-categorical-vivid-color-05-default': '#00818c',
  '--dt-colors-charts-categorical-vivid-color-06-default': '#f57323',
  '--dt-colors-charts-categorical-vivid-color-07-default': '#cc75e6',
  '--dt-colors-charts-categorical-vivid-color-08-default': '#009f68',
  '--dt-colors-charts-categorical-vivid-color-09-default': '#1bd4b7',
  '--dt-colors-charts-categorical-vivid-color-10-default': '#ffb895',
  '--dt-colors-charts-categorical-vivid-color-11-default': '#b9a9ff',
  '--dt-colors-charts-categorical-vivid-color-12-default': '#5c9eff',
  '--dt-colors-charts-categorical-vivid-color-13-default': '#c90084',
  '--dt-colors-charts-categorical-vivid-color-14-default': '#0057bf',
  '--dt-colors-charts-categorical-vivid-color-15-default': '#358700',
  '--dt-colors-charts-categorical-themed-purple-rain-color-01-default':
    '#9000af',
  '--dt-colors-charts-categorical-themed-purple-rain-color-02-default':
    '#af7e00',
  '--dt-colors-charts-categorical-themed-purple-rain-color-03-default':
    '#eb009b',
  '--dt-colors-charts-categorical-themed-purple-rain-color-04-default':
    '#8e5fff',
  '--dt-colors-charts-categorical-themed-purple-rain-color-05-default':
    '#844e2f',
  '--dt-colors-charts-categorical-themed-purple-rain-color-06-default':
    '#d40036',
  '--dt-colors-charts-categorical-themed-swamps-color-01-default': '#006e5e',
  '--dt-colors-charts-categorical-themed-swamps-color-02-default': '#82878b',
  '--dt-colors-charts-categorical-themed-swamps-color-03-default': '#409f00',
  '--dt-colors-charts-categorical-themed-swamps-color-04-default': '#844e2f',
  '--dt-colors-charts-categorical-themed-swamps-color-05-default': '#484b4d',
  '--dt-colors-charts-categorical-themed-swamps-color-06-default': '#af7e00',
  '--dt-colors-charts-categorical-themed-fireplace-color-01-default': '#b1002c',
  '--dt-colors-charts-categorical-themed-fireplace-color-02-default': '#eb009b',
  '--dt-colors-charts-categorical-themed-fireplace-color-03-default': '#d55d00',
  '--dt-colors-charts-categorical-themed-fireplace-color-04-default': '#af7e00',
  '--dt-colors-charts-categorical-themed-fireplace-color-05-default': '#844e2f',
  '--dt-colors-charts-categorical-themed-fireplace-color-06-default': '#9000af',
  '--dt-colors-charts-categorical-themed-blue-steel-color-01-default':
    '#0098a5',
  '--dt-colors-charts-categorical-themed-blue-steel-color-02-default':
    '#82878b',
  '--dt-colors-charts-categorical-themed-blue-steel-color-03-default':
    '#2380ff',
  '--dt-colors-charts-categorical-themed-blue-steel-color-04-default':
    '#8e5fff',
  '--dt-colors-charts-categorical-themed-blue-steel-color-05-default':
    '#00459a',
  '--dt-colors-charts-categorical-themed-blue-steel-color-06-default':
    '#484b4d',
  '--dt-colors-charts-categorical-themed-neon-color-01-default': '#5600b8',
  '--dt-colors-charts-categorical-themed-neon-color-02-default': '#d7b43b',
  '--dt-colors-charts-categorical-themed-neon-color-03-default': '#1bd4b7',
  '--dt-colors-charts-categorical-themed-neon-color-04-default': '#c90084',
  '--dt-colors-charts-categorical-themed-neon-color-05-default': '#60b73c',
  '--dt-colors-charts-categorical-themed-neon-color-06-default': '#d55d00',
  '--dt-colors-charts-categorical-themed-aurora-color-01-default': '#cc75e6',
  '--dt-colors-charts-categorical-themed-aurora-color-02-default': '#00bb7b',
  '--dt-colors-charts-categorical-themed-aurora-color-03-default': '#ad00d2',
  '--dt-colors-charts-categorical-themed-aurora-color-04-default': '#f990c4',
  '--dt-colors-charts-categorical-themed-aurora-color-05-default': '#7ce0ca',
  '--dt-colors-charts-categorical-themed-aurora-color-06-default': '#89cc72',
  '--dt-colors-charts-categorical-themed-overdrive-color-01-default': '#c90084',
  '--dt-colors-charts-categorical-themed-overdrive-color-02-default': '#d7b43b',
  '--dt-colors-charts-categorical-themed-overdrive-color-03-default': '#d40036',
  '--dt-colors-charts-categorical-themed-overdrive-color-04-default': '#f57323',
  '--dt-colors-charts-categorical-themed-overdrive-color-05-default': '#ffb895',
  '--dt-colors-charts-categorical-themed-overdrive-color-06-default': '#af7e00',
  '--dt-colors-charts-categorical-themed-tide-color-01-default': '#56d298',
  '--dt-colors-charts-categorical-themed-tide-color-02-default': '#7f2eff',
  '--dt-colors-charts-categorical-themed-tide-color-03-default': '#2380ff',
  '--dt-colors-charts-categorical-themed-tide-color-04-default': '#006a74',
  '--dt-colors-charts-categorical-themed-tide-color-05-default': '#b9a9ff',
  '--dt-colors-charts-categorical-themed-tide-color-06-default': '#009c86',
  '--dt-colors-charts-status-ideal-default': '#00bb7b',
  '--dt-colors-charts-status-good-default': '#006ae5',
  '--dt-colors-charts-status-neutral-default': '#36383a',
  '--dt-colors-charts-status-warning-default': '#d7b43b',
  '--dt-colors-charts-status-critical-default': '#d40036',
  '--dt-colors-charts-logstatus-error-default': '#d40036',
  '--dt-colors-charts-logstatus-warning-default': '#d7b43b',
  '--dt-colors-charts-logstatus-info-default': '#0057bf',
  '--dt-colors-charts-logstatus-none-default': '#484b4d',
  '--dt-colors-charts-loglevel-emergency-default': '#8e0021',
  '--dt-colors-charts-loglevel-error-default': '#d40036',
  '--dt-colors-charts-loglevel-alert-default': '#c90084',
  '--dt-colors-charts-loglevel-critical-default': '#ed68ae',
  '--dt-colors-charts-loglevel-severe-default': '#d55d00',
  '--dt-colors-charts-loglevel-warning-default': '#d7b43b',
  '--dt-colors-charts-loglevel-notice-default': '#009f68',
  '--dt-colors-charts-loglevel-info-default': '#0057bf',
  '--dt-colors-charts-loglevel-debug-default': '#8e5fff',
  '--dt-colors-charts-loglevel-none-default': '#484b4d',
  '--dt-colors-charts-apdex-excellent-default': '#009f68',
  '--dt-colors-charts-apdex-good-default': '#007048',
  '--dt-colors-charts-apdex-fair-default': '#d7b43b',
  '--dt-colors-charts-apdex-poor-default': '#d55d00',
  '--dt-colors-charts-apdex-unacceptable-default': '#d40036',
  '--dt-colors-charts-security-risk-level-muted-default': '#82878b',
  '--dt-colors-charts-security-risk-level-critical-default': '#8e0021',
  '--dt-colors-charts-security-risk-level-high-default': '#d40036',
  '--dt-colors-charts-security-risk-level-medium-default': '#d7b43b',
  '--dt-colors-charts-security-risk-level-low-default': '#0057bf',
  '--dt-colors-charts-security-risk-level-none-default': '#484b4d',
  '--dt-colors-charts-vulnerability-status-muted-default': '#82878b',
  '--dt-colors-charts-vulnerability-status-resolved-default': '#009f68',
  '--dt-colors-charts-vulnerability-status-affected-default': '#d40036',
  '--dt-colors-charts-threshold-good-default': '#009f68',
  '--dt-colors-charts-threshold-warning-default': '#d7b43b',
  '--dt-colors-charts-threshold-bad-default': '#d40036',
  '--dt-colors-charts-rainbow-red-default': '#d40036',
  '--dt-colors-charts-rainbow-orange-default': '#d55d00',
  '--dt-colors-charts-rainbow-yellow-default': '#d7b43b',
  '--dt-colors-charts-rainbow-moss-default': '#009f68',
  '--dt-colors-charts-rainbow-blue-default': '#0057bf',
  '--dt-colors-charts-rainbow-magenta-default': '#9000af',
  '--dt-colors-charts-sequential-pink-purple-color-01-default': '#eb009b',
  '--dt-colors-charts-sequential-pink-purple-color-02-default': '#d32a9b',
  '--dt-colors-charts-sequential-pink-purple-color-03-default': '#bb399c',
  '--dt-colors-charts-sequential-pink-purple-color-04-default': '#a3419c',
  '--dt-colors-charts-sequential-pink-purple-color-05-default': '#8a469c',
  '--dt-colors-charts-sequential-pink-purple-color-06-default': '#71499c',
  '--dt-colors-charts-sequential-pink-purple-color-07-default': '#57499b',
  '--dt-colors-charts-sequential-pink-purple-color-08-default': '#39489b',
  '--dt-colors-charts-sequential-pink-purple-color-09-default': '#00459a',
  '--dt-colors-charts-sequential-blue-turquoise-color-01-default': '#00459a',
  '--dt-colors-charts-sequential-blue-turquoise-color-02-default': '#005199',
  '--dt-colors-charts-sequential-blue-turquoise-color-03-default': '#005d97',
  '--dt-colors-charts-sequential-blue-turquoise-color-04-default': '#006895',
  '--dt-colors-charts-sequential-blue-turquoise-color-05-default': '#007393',
  '--dt-colors-charts-sequential-blue-turquoise-color-06-default': '#007d91',
  '--dt-colors-charts-sequential-blue-turquoise-color-07-default': '#00888e',
  '--dt-colors-charts-sequential-blue-turquoise-color-08-default': '#00928a',
  '--dt-colors-charts-sequential-blue-turquoise-color-09-default': '#009c86',
  '--dt-colors-charts-sequential-blue-color-01-default': '#003477',
  '--dt-colors-charts-sequential-blue-color-02-default': '#00459a',
  '--dt-colors-charts-sequential-blue-color-03-default': '#0057bf',
  '--dt-colors-charts-sequential-blue-color-04-default': '#006ae5',
  '--dt-colors-charts-sequential-blue-color-05-default': '#2380ff',
  '--dt-colors-charts-sequential-blue-color-06-default': '#5c9eff',
  '--dt-colors-charts-sequential-blue-color-07-default': '#8ab9ff',
  '--dt-colors-charts-sequential-blue-color-08-default': '#abcdff',
  '--dt-colors-charts-sequential-blue-color-09-default': '#cae0ff',
  '--dt-colors-charts-sequential-grey-color-01-default': '#36383a',
  '--dt-colors-charts-sequential-grey-color-02-default': '#484b4d',
  '--dt-colors-charts-sequential-grey-color-03-default': '#5b5e61',
  '--dt-colors-charts-sequential-grey-color-04-default': '#6e7276',
  '--dt-colors-charts-sequential-grey-color-05-default': '#82878b',
  '--dt-colors-charts-sequential-grey-color-06-default': '#9b9fa3',
  '--dt-colors-charts-sequential-grey-color-07-default': '#b5b8bb',
  '--dt-colors-charts-sequential-grey-color-08-default': '#c8cbcd',
  '--dt-colors-charts-sequential-grey-color-09-default': '#dddee0',
  '--dt-colors-charts-sequential-moss-color-01-default': '#00442a',
  '--dt-colors-charts-sequential-moss-color-02-default': '#005938',
  '--dt-colors-charts-sequential-moss-color-03-default': '#007048',
  '--dt-colors-charts-sequential-moss-color-04-default': '#008758',
  '--dt-colors-charts-sequential-moss-color-05-default': '#009f68',
  '--dt-colors-charts-sequential-moss-color-06-default': '#00bb7b',
  '--dt-colors-charts-sequential-moss-color-07-default': '#56d298',
  '--dt-colors-charts-sequential-moss-color-08-default': '#8fdfb4',
  '--dt-colors-charts-sequential-moss-color-09-default': '#b6edce',
  '--dt-colors-charts-sequential-turquoise-color-01-default': '#004238',
  '--dt-colors-charts-sequential-turquoise-color-02-default': '#00574a',
  '--dt-colors-charts-sequential-turquoise-color-03-default': '#006e5e',
  '--dt-colors-charts-sequential-turquoise-color-04-default': '#008472',
  '--dt-colors-charts-sequential-turquoise-color-05-default': '#009c86',
  '--dt-colors-charts-sequential-turquoise-color-06-default': '#00b89e',
  '--dt-colors-charts-sequential-turquoise-color-07-default': '#1bd4b7',
  '--dt-colors-charts-sequential-turquoise-color-08-default': '#7ce0ca',
  '--dt-colors-charts-sequential-turquoise-color-09-default': '#aceede',
  '--dt-colors-charts-sequential-pink-color-01-default': '#680042',
  '--dt-colors-charts-sequential-pink-color-02-default': '#870057',
  '--dt-colors-charts-sequential-pink-color-03-default': '#a7006d',
  '--dt-colors-charts-sequential-pink-color-04-default': '#c90084',
  '--dt-colors-charts-sequential-pink-color-05-default': '#eb009b',
  '--dt-colors-charts-sequential-pink-color-06-default': '#ed68ae',
  '--dt-colors-charts-sequential-pink-color-07-default': '#f990c4',
  '--dt-colors-charts-sequential-pink-color-08-default': '#fdb0d4',
  '--dt-colors-charts-sequential-pink-color-09-default': '#ffcee4',
  '--dt-colors-charts-sequential-yellow-color-01-default': '#4b3400',
  '--dt-colors-charts-sequential-yellow-color-02-default': '#634500',
  '--dt-colors-charts-sequential-yellow-color-03-default': '#7b5800',
  '--dt-colors-charts-sequential-yellow-color-04-default': '#956a00',
  '--dt-colors-charts-sequential-yellow-color-05-default': '#af7e00',
  '--dt-colors-charts-sequential-yellow-color-06-default': '#c79800',
  '--dt-colors-charts-sequential-yellow-color-07-default': '#d7b43b',
  '--dt-colors-charts-sequential-yellow-color-08-default': '#e2c97d',
  '--dt-colors-charts-sequential-yellow-color-09-default': '#efdda9',
  '--dt-colors-charts-sequential-petrol-color-01-default': '#004047',
  '--dt-colors-charts-sequential-petrol-color-02-default': '#00555d',
  '--dt-colors-charts-sequential-petrol-color-03-default': '#006a74',
  '--dt-colors-charts-sequential-petrol-color-04-default': '#00818c',
  '--dt-colors-charts-sequential-petrol-color-05-default': '#0098a5',
  '--dt-colors-charts-sequential-petrol-color-06-default': '#00b3c3',
  '--dt-colors-charts-sequential-petrol-color-07-default': '#00cfe1',
  '--dt-colors-charts-sequential-petrol-color-08-default': '#73ddea',
  '--dt-colors-charts-sequential-petrol-color-09-default': '#a7ecf5',
  '--dt-colors-charts-sequential-purple-color-01-default': '#41008f',
  '--dt-colors-charts-sequential-purple-color-02-default': '#5600b8',
  '--dt-colors-charts-sequential-purple-color-03-default': '#6c00e3',
  '--dt-colors-charts-sequential-purple-color-04-default': '#7f2eff',
  '--dt-colors-charts-sequential-purple-color-05-default': '#8e5fff',
  '--dt-colors-charts-sequential-purple-color-06-default': '#a287ff',
  '--dt-colors-charts-sequential-purple-color-07-default': '#b9a9ff',
  '--dt-colors-charts-sequential-purple-color-08-default': '#cbc1ff',
  '--dt-colors-charts-sequential-purple-color-09-default': '#ded8ff',
  '--dt-colors-charts-sequential-pear-color-01-default': '#174400',
  '--dt-colors-charts-sequential-pear-color-02-default': '#205900',
  '--dt-colors-charts-sequential-pear-color-03-default': '#2b7000',
  '--dt-colors-charts-sequential-pear-color-04-default': '#358700',
  '--dt-colors-charts-sequential-pear-color-05-default': '#409f00',
  '--dt-colors-charts-sequential-pear-color-06-default': '#60b73c',
  '--dt-colors-charts-sequential-pear-color-07-default': '#89cc72',
  '--dt-colors-charts-sequential-pear-color-08-default': '#abda9b',
  '--dt-colors-charts-sequential-pear-color-09-default': '#c8eabd',
  '--dt-colors-charts-sequential-brown-color-01-default': '#512e19',
  '--dt-colors-charts-sequential-brown-color-02-default': '#6a3e24',
  '--dt-colors-charts-sequential-brown-color-03-default': '#844e2f',
  '--dt-colors-charts-sequential-brown-color-04-default': '#9f5f3a',
  '--dt-colors-charts-sequential-brown-color-05-default': '#bb7146',
  '--dt-colors-charts-sequential-brown-color-06-default': '#db8654',
  '--dt-colors-charts-sequential-brown-color-07-default': '#e9a680',
  '--dt-colors-charts-sequential-brown-color-08-default': '#efbfa5',
  '--dt-colors-charts-sequential-brown-color-09-default': '#f4d7c8',
  '--dt-colors-charts-sequential-red-color-01-default': '#6e0017',
  '--dt-colors-charts-sequential-red-color-02-default': '#8e0021',
  '--dt-colors-charts-sequential-red-color-03-default': '#b1002c',
  '--dt-colors-charts-sequential-red-color-04-default': '#d40036',
  '--dt-colors-charts-sequential-red-color-05-default': '#f80042',
  '--dt-colors-charts-sequential-red-color-06-default': '#fa676e',
  '--dt-colors-charts-sequential-red-color-07-default': '#ff9495',
  '--dt-colors-charts-sequential-red-color-08-default': '#ffb4b3',
  '--dt-colors-charts-sequential-red-color-09-default': '#ffd1d0',
  '--dt-colors-charts-sequential-magenta-color-01-default': '#59006d',
  '--dt-colors-charts-sequential-magenta-color-02-default': '#74008d',
  '--dt-colors-charts-sequential-magenta-color-03-default': '#9000af',
  '--dt-colors-charts-sequential-magenta-color-04-default': '#ad00d2',
  '--dt-colors-charts-sequential-magenta-color-05-default': '#c337e8',
  '--dt-colors-charts-sequential-magenta-color-06-default': '#cc75e6',
  '--dt-colors-charts-sequential-magenta-color-07-default': '#dc9af1',
  '--dt-colors-charts-sequential-magenta-color-08-default': '#e6b6f5',
  '--dt-colors-charts-sequential-magenta-color-09-default': '#f2d0fd',
  '--dt-colors-charts-sequential-orange-color-01-default': '#5d2400',
  '--dt-colors-charts-sequential-orange-color-02-default': '#7a3200',
  '--dt-colors-charts-sequential-orange-color-03-default': '#974000',
  '--dt-colors-charts-sequential-orange-color-04-default': '#b64e00',
  '--dt-colors-charts-sequential-orange-color-05-default': '#d55d00',
  '--dt-colors-charts-sequential-orange-color-06-default': '#f57323',
  '--dt-colors-charts-sequential-orange-color-07-default': '#ff9a66',
  '--dt-colors-charts-sequential-orange-color-08-default': '#ffb895',
  '--dt-colors-charts-sequential-orange-color-09-default': '#ffd3bf',
  '--dt-colors-charts-diverging-orange-blue-color-01-default': '#5d2400',
  '--dt-colors-charts-diverging-orange-blue-color-02-default': '#974000',
  '--dt-colors-charts-diverging-orange-blue-color-03-default': '#d55d00',
  '--dt-colors-charts-diverging-orange-blue-color-04-default': '#ff9a66',
  '--dt-colors-charts-diverging-orange-blue-color-05-default': '#ffd3bf',
  '--dt-colors-charts-diverging-orange-blue-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-orange-blue-color-07-default': '#cae0ff',
  '--dt-colors-charts-diverging-orange-blue-color-08-default': '#8ab9ff',
  '--dt-colors-charts-diverging-orange-blue-color-09-default': '#2380ff',
  '--dt-colors-charts-diverging-orange-blue-color-10-default': '#0057bf',
  '--dt-colors-charts-diverging-orange-blue-color-11-default': '#003477',
  '--dt-colors-charts-diverging-red-blue-color-01-default': '#6e0017',
  '--dt-colors-charts-diverging-red-blue-color-02-default': '#b1002c',
  '--dt-colors-charts-diverging-red-blue-color-03-default': '#f80042',
  '--dt-colors-charts-diverging-red-blue-color-04-default': '#ff9495',
  '--dt-colors-charts-diverging-red-blue-color-05-default': '#ffd1d0',
  '--dt-colors-charts-diverging-red-blue-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-blue-color-07-default': '#cae0ff',
  '--dt-colors-charts-diverging-red-blue-color-08-default': '#8ab9ff',
  '--dt-colors-charts-diverging-red-blue-color-09-default': '#2380ff',
  '--dt-colors-charts-diverging-red-blue-color-10-default': '#0057bf',
  '--dt-colors-charts-diverging-red-blue-color-11-default': '#003477',
  '--dt-colors-charts-diverging-red-purple-color-01-default': '#6e0017',
  '--dt-colors-charts-diverging-red-purple-color-02-default': '#b1002c',
  '--dt-colors-charts-diverging-red-purple-color-03-default': '#f80042',
  '--dt-colors-charts-diverging-red-purple-color-04-default': '#ff9495',
  '--dt-colors-charts-diverging-red-purple-color-05-default': '#ffd1d0',
  '--dt-colors-charts-diverging-red-purple-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-purple-color-07-default': '#ded8ff',
  '--dt-colors-charts-diverging-red-purple-color-08-default': '#b9a9ff',
  '--dt-colors-charts-diverging-red-purple-color-09-default': '#8e5fff',
  '--dt-colors-charts-diverging-red-purple-color-10-default': '#6c00e3',
  '--dt-colors-charts-diverging-red-purple-color-11-default': '#41008f',
  '--dt-colors-charts-diverging-blue-moss-color-01-default': '#003477',
  '--dt-colors-charts-diverging-blue-moss-color-02-default': '#0057bf',
  '--dt-colors-charts-diverging-blue-moss-color-03-default': '#2380ff',
  '--dt-colors-charts-diverging-blue-moss-color-04-default': '#8ab9ff',
  '--dt-colors-charts-diverging-blue-moss-color-05-default': '#cae0ff',
  '--dt-colors-charts-diverging-blue-moss-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-blue-moss-color-07-default': '#b6edce',
  '--dt-colors-charts-diverging-blue-moss-color-08-default': '#56d298',
  '--dt-colors-charts-diverging-blue-moss-color-09-default': '#009f68',
  '--dt-colors-charts-diverging-blue-moss-color-10-default': '#007048',
  '--dt-colors-charts-diverging-blue-moss-color-11-default': '#00442a',
  '--dt-colors-charts-diverging-purple-yellow-color-01-default': '#41008f',
  '--dt-colors-charts-diverging-purple-yellow-color-02-default': '#6c00e3',
  '--dt-colors-charts-diverging-purple-yellow-color-03-default': '#8e5fff',
  '--dt-colors-charts-diverging-purple-yellow-color-04-default': '#b9a9ff',
  '--dt-colors-charts-diverging-purple-yellow-color-05-default': '#ded8ff',
  '--dt-colors-charts-diverging-purple-yellow-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-purple-yellow-color-07-default': '#efdda9',
  '--dt-colors-charts-diverging-purple-yellow-color-08-default': '#d7b43b',
  '--dt-colors-charts-diverging-purple-yellow-color-09-default': '#af7e00',
  '--dt-colors-charts-diverging-purple-yellow-color-10-default': '#7b5800',
  '--dt-colors-charts-diverging-purple-yellow-color-11-default': '#4b3400',
  '--dt-colors-charts-diverging-red-green-color-01-default': '#6e0017',
  '--dt-colors-charts-diverging-red-green-color-02-default': '#b1002c',
  '--dt-colors-charts-diverging-red-green-color-03-default': '#f80042',
  '--dt-colors-charts-diverging-red-green-color-04-default': '#ff9495',
  '--dt-colors-charts-diverging-red-green-color-05-default': '#ffd1d0',
  '--dt-colors-charts-diverging-red-green-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-red-green-color-07-default': '#b6edce',
  '--dt-colors-charts-diverging-red-green-color-08-default': '#56d298',
  '--dt-colors-charts-diverging-red-green-color-09-default': '#009f68',
  '--dt-colors-charts-diverging-red-green-color-10-default': '#007048',
  '--dt-colors-charts-diverging-red-green-color-11-default': '#00442a',
  '--dt-colors-charts-diverging-orange-petrol-color-01-default': '#5d2400',
  '--dt-colors-charts-diverging-orange-petrol-color-02-default': '#974000',
  '--dt-colors-charts-diverging-orange-petrol-color-03-default': '#d55d00',
  '--dt-colors-charts-diverging-orange-petrol-color-04-default': '#ff9a66',
  '--dt-colors-charts-diverging-orange-petrol-color-05-default': '#ffd3bf',
  '--dt-colors-charts-diverging-orange-petrol-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-orange-petrol-color-07-default': '#a7ecf5',
  '--dt-colors-charts-diverging-orange-petrol-color-08-default': '#00cfe1',
  '--dt-colors-charts-diverging-orange-petrol-color-09-default': '#0098a5',
  '--dt-colors-charts-diverging-orange-petrol-color-10-default': '#006a74',
  '--dt-colors-charts-diverging-orange-petrol-color-11-default': '#004047',
  '--dt-colors-charts-diverging-pink-green-color-01-default': '#680042',
  '--dt-colors-charts-diverging-pink-green-color-02-default': '#a7006d',
  '--dt-colors-charts-diverging-pink-green-color-03-default': '#eb009b',
  '--dt-colors-charts-diverging-pink-green-color-04-default': '#f990c4',
  '--dt-colors-charts-diverging-pink-green-color-05-default': '#ffcee4',
  '--dt-colors-charts-diverging-pink-green-color-06-default': '#e6e4e0',
  '--dt-colors-charts-diverging-pink-green-color-07-default': '#b6edce',
  '--dt-colors-charts-diverging-pink-green-color-08-default': '#56d298',
  '--dt-colors-charts-diverging-pink-green-color-09-default': '#009f68',
  '--dt-colors-charts-diverging-pink-green-color-10-default': '#007048',
  '--dt-colors-charts-diverging-pink-green-color-11-default': '#00442a',
  /** Use as the default layer, for elements that do not need to be explicitly layered on top of other elements. */
  '--dt-elevations-default': '1',
  /** Use for elements that are pinned to a certain location while also staying on top of other content. */
  '--dt-elevations-sticky': '10',
  /** Use for elements that appear on top of all other content on the page. */
  '--dt-elevations-overlay': '20',
  /** Use for notifications that should always be visible on top of other content. */
  '--dt-elevations-notification': '1999999999',
  '--dt-spacings-size-0': '0',
  '--dt-spacings-size-2': '2px',
  '--dt-spacings-size-4': '4px',
  '--dt-spacings-size-6': '6px',
  '--dt-spacings-size-8': '8px',
  '--dt-spacings-size-12': '12px',
  '--dt-spacings-size-16': '16px',
  '--dt-spacings-size-20': '20px',
  '--dt-spacings-size-24': '24px',
  '--dt-spacings-size-28': '28px',
  '--dt-spacings-size-32': '32px',
  '--dt-spacings-size-36': '36px',
  '--dt-spacings-size-40': '40px',
  '--dt-spacings-size-48': '48px',
  '--dt-spacings-size-56': '56px',
  '--dt-spacings-size-64': '64px',
  '--dt-typography-display-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-1-weight': '600',
  '--dt-typography-display-level-1-size': '64px',
  '--dt-typography-display-level-1-line-height': '1.1875',
  '--dt-typography-display-level-1-text-decoration': 'none',
  '--dt-typography-display-level-1-text-transform': 'none',
  '--dt-typography-display-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-2-weight': '600',
  '--dt-typography-display-level-2-size': '56px',
  '--dt-typography-display-level-2-line-height': '1.2142857143',
  '--dt-typography-display-level-2-text-decoration': 'none',
  '--dt-typography-display-level-2-text-transform': 'none',
  '--dt-typography-display-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-display-level-3-weight': '600',
  '--dt-typography-display-level-3-size': '48px',
  '--dt-typography-display-level-3-line-height': '1.25',
  '--dt-typography-display-level-3-text-decoration': 'none',
  '--dt-typography-display-level-3-text-transform': 'none',
  '--dt-typography-heading-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-1-weight': '600',
  '--dt-typography-heading-level-1-size': '32px',
  '--dt-typography-heading-level-1-line-height': '1.25',
  '--dt-typography-heading-level-1-text-decoration': 'none',
  '--dt-typography-heading-level-1-text-transform': 'none',
  '--dt-typography-heading-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-2-weight': '600',
  '--dt-typography-heading-level-2-size': '28px',
  '--dt-typography-heading-level-2-line-height': '1.2857142857',
  '--dt-typography-heading-level-2-text-decoration': 'none',
  '--dt-typography-heading-level-2-text-transform': 'none',
  '--dt-typography-heading-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-3-weight': '600',
  '--dt-typography-heading-level-3-size': '24px',
  '--dt-typography-heading-level-3-line-height': '1.3333333333',
  '--dt-typography-heading-level-3-text-decoration': 'none',
  '--dt-typography-heading-level-3-text-transform': 'none',
  '--dt-typography-heading-level-4-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-4-weight': '600',
  '--dt-typography-heading-level-4-size': '20px',
  '--dt-typography-heading-level-4-line-height': '1.4',
  '--dt-typography-heading-level-4-text-decoration': 'none',
  '--dt-typography-heading-level-4-text-transform': 'none',
  '--dt-typography-heading-level-5-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-5-weight': '600',
  '--dt-typography-heading-level-5-size': '16px',
  '--dt-typography-heading-level-5-line-height': '1.5',
  '--dt-typography-heading-level-5-text-decoration': 'none',
  '--dt-typography-heading-level-5-text-transform': 'none',
  '--dt-typography-heading-level-6-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-heading-level-6-weight': '600',
  '--dt-typography-heading-level-6-size': '14px',
  '--dt-typography-heading-level-6-line-height': '1.4285714286',
  '--dt-typography-heading-level-6-text-decoration': 'none',
  '--dt-typography-heading-level-6-text-transform': 'none',
  '--dt-typography-subtitle-display-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-1-weight': '400',
  '--dt-typography-subtitle-display-level-1-size': '28px',
  '--dt-typography-subtitle-display-level-1-line-height': '1.4285714286',
  '--dt-typography-subtitle-display-level-1-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-1-text-transform': 'none',
  '--dt-typography-subtitle-display-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-2-weight': '400',
  '--dt-typography-subtitle-display-level-2-size': '24px',
  '--dt-typography-subtitle-display-level-2-line-height': '1.5',
  '--dt-typography-subtitle-display-level-2-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-2-text-transform': 'none',
  '--dt-typography-subtitle-display-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-display-level-3-weight': '400',
  '--dt-typography-subtitle-display-level-3-size': '21px',
  '--dt-typography-subtitle-display-level-3-line-height': '1.5238095238',
  '--dt-typography-subtitle-display-level-3-text-decoration': 'none',
  '--dt-typography-subtitle-display-level-3-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-1-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-1-weight': '400',
  '--dt-typography-subtitle-heading-level-1-size': '21px',
  '--dt-typography-subtitle-heading-level-1-line-height': '1.5238095238',
  '--dt-typography-subtitle-heading-level-1-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-1-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-2-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-2-weight': '400',
  '--dt-typography-subtitle-heading-level-2-size': '18px',
  '--dt-typography-subtitle-heading-level-2-line-height': '1.5555555556',
  '--dt-typography-subtitle-heading-level-2-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-2-text-transform': 'none',
  '--dt-typography-subtitle-heading-level-3-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-subtitle-heading-level-3-weight': '400',
  '--dt-typography-subtitle-heading-level-3-size': '16px',
  '--dt-typography-subtitle-heading-level-3-line-height': '1.5',
  '--dt-typography-subtitle-heading-level-3-text-decoration': 'none',
  '--dt-typography-subtitle-heading-level-3-text-transform': 'none',
  '--dt-typography-text-base-default-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-base-default-weight': '400',
  '--dt-typography-text-base-default-size': '14px',
  '--dt-typography-text-base-default-line-height': '1.4285714286',
  '--dt-typography-text-base-default-text-decoration': 'none',
  '--dt-typography-text-base-default-text-transform': 'none',
  '--dt-typography-text-base-emphasized-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-base-emphasized-weight': '500',
  '--dt-typography-text-base-emphasized-size': '14px',
  '--dt-typography-text-base-emphasized-line-height': '1.4285714286',
  '--dt-typography-text-base-emphasized-text-decoration': 'none',
  '--dt-typography-text-base-emphasized-text-transform': 'none',
  '--dt-typography-text-small-default-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-small-default-weight': '400',
  '--dt-typography-text-small-default-size': '12px',
  '--dt-typography-text-small-default-line-height': '1.333333333',
  '--dt-typography-text-small-default-text-decoration': 'none',
  '--dt-typography-text-small-default-text-transform': 'none',
  '--dt-typography-text-small-emphasized-family':
    'DynatraceFlow,Roboto,Helvetica,sans-serif',
  '--dt-typography-text-small-emphasized-weight': '500',
  '--dt-typography-text-small-emphasized-size': '12px',
  '--dt-typography-text-small-emphasized-line-height': '1.333333333',
  '--dt-typography-text-small-emphasized-text-decoration': 'none',
  '--dt-typography-text-small-emphasized-text-transform': 'none',
  '--dt-typography-code-base-default-family': 'Roboto Mono,monospace',
  '--dt-typography-code-base-default-weight': '400',
  '--dt-typography-code-base-default-size': '14px',
  '--dt-typography-code-base-default-line-height': '1.4285714286',
  '--dt-typography-code-base-default-text-decoration': 'none',
  '--dt-typography-code-base-default-text-transform': 'none',
  '--dt-typography-code-base-emphasized-family': 'Roboto Mono,monospace',
  '--dt-typography-code-base-emphasized-weight': '500',
  '--dt-typography-code-base-emphasized-size': '14px',
  '--dt-typography-code-base-emphasized-line-height': '1.4285714286',
  '--dt-typography-code-base-emphasized-text-decoration': 'none',
  '--dt-typography-code-base-emphasized-text-transform': 'none',
  '--dt-typography-code-small-default-family': 'Roboto Mono,monospace',
  '--dt-typography-code-small-default-weight': '400',
  '--dt-typography-code-small-default-size': '12px',
  '--dt-typography-code-small-default-line-height': '1.333333333',
  '--dt-typography-code-small-default-text-decoration': 'none',
  '--dt-typography-code-small-default-text-transform': 'none',
  '--dt-typography-code-small-emphasized-family': 'Roboto Mono,monospace',
  '--dt-typography-code-small-emphasized-weight': '500',
  '--dt-typography-code-small-emphasized-size': '12px',
  '--dt-typography-code-small-emphasized-line-height': '1.333333333',
  '--dt-typography-code-small-emphasized-text-decoration': 'none',
  '--dt-typography-code-small-emphasized-text-transform': 'none',
  '--dt-animations-open-duration-fast': '170ms',
  '--dt-animations-open-duration-base': '250ms',
  '--dt-animations-open-duration-slow': '400ms',
  '--dt-animations-open-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-close-duration-fast': '0ms',
  '--dt-animations-close-duration-base': '170ms',
  '--dt-animations-close-duration-slow': '250ms',
  '--dt-animations-close-easing': 'cubic-bezier(0.5, 0, 1, 1)',
  '--dt-animations-slide-in-duration-fast': '200ms',
  '--dt-animations-slide-in-duration-base': '300ms',
  '--dt-animations-slide-in-duration-slow': '400ms',
  '--dt-animations-slide-in-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-slide-out-duration-fast': '150ms',
  '--dt-animations-slide-out-duration-base': '250ms',
  '--dt-animations-slide-out-duration-slow': '350ms',
  '--dt-animations-slide-out-easing': 'cubic-bezier(0.8, 0, 0.5, 1)',
  '--dt-animations-fade-in-duration-fast': '150ms',
  '--dt-animations-fade-in-duration-base': '250ms',
  '--dt-animations-fade-in-duration-slow': '350ms',
  '--dt-animations-fade-in-easing': 'cubic-bezier(0.5, 0, 1, 1)',
  '--dt-animations-fade-out-duration-fast': '150ms',
  '--dt-animations-fade-out-duration-base': '250ms',
  '--dt-animations-fade-out-duration-slow': '350ms',
  '--dt-animations-fade-out-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-hover-duration-base': '150ms',
  '--dt-animations-hover-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-staggered-motion-duration-fast': '250ms',
  '--dt-animations-staggered-motion-duration-base': '350ms',
  '--dt-animations-staggered-motion-duration-slow': '400ms',
  '--dt-animations-staggered-motion-offset-fast': '20ms',
  '--dt-animations-staggered-motion-offset-base': '30ms',
  '--dt-animations-staggered-motion-offset-slow': '50ms',
  '--dt-animations-staggered-motion-easing': 'cubic-bezier(0, 0, 0.2, 1)',
  '--dt-animations-expand-collapse-duration-fast': '250ms',
  '--dt-animations-expand-collapse-duration-base': '400ms',
  '--dt-animations-expand-collapse-duration-slow': '600ms',
  '--dt-animations-expand-collapse-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  '--dt-animations-move-duration-fast': '150ms',
  '--dt-animations-move-duration-base': '400ms',
  '--dt-animations-move-duration-slow': '600ms',
  '--dt-animations-move-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  '--dt-animations-rescale-duration-fast': '170ms',
  '--dt-animations-rescale-duration-base': '250ms',
  '--dt-animations-rescale-duration-slow': '400ms',
  '--dt-animations-rescale-easing': 'cubic-bezier(0.4, 0, 0.2, 1)',
  /** Use to convey the deceleration of an object, such as when it's coming to a stop. It starts at a fast pace and then slows down at the end. */
  '--dt-easings-decelerate': 'cubic-bezier(0, 0, 0.2, 1)',
  /** Use to convey the acceleration of an object, such as when it's being launched. It starts at a slow pace and then speeds up at the end. */
  '--dt-easings-accelerate': 'cubic-bezier(0.5, 0, 1, 1)',
  /** Use to draw attention to an object. It starts slowly, accelerates in the middle, and then slows down again at the end. */
  '--dt-easings-slow-in-fast-out': 'cubic-bezier(0.8, 0, 0.5, 1)',
  /** Use to move or scale objects. It starts slowly, quickly accelerates in the middle, and slows down at the end. */
  '--dt-easings-fast-in-slow-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
  /** Use to convey a playful or elastic effect, such as when an object bounces or stretches. It overshoots its target position before settling back into place. */
  '--dt-easings-out-back': 'cubic-bezier(0.4, 1.6, 0.7, 1)',
  /** Use to create dynamic, nonlinear rotation that adds energy and movement, ideal for rotating loading indicators. */
  '--dt-easings-rotate-elastic': 'cubic-bezier(0.8, 0.3, 0.3, 0.8)',
  '--dt-timings-instant-default': '0ms',
  '--dt-timings-offset-short': '20ms',
  '--dt-timings-offset-medium': '30ms',
  '--dt-timings-offset-long': '100ms',
  '--dt-timings-offset-default': '50ms',
  '--dt-timings-fast-quick': '150ms',
  '--dt-timings-fast-default': '170ms',
  '--dt-timings-fast-moderate': '200ms',
  '--dt-timings-base-quick': '250ms',
  '--dt-timings-base-default': '300ms',
  '--dt-timings-base-moderate': '350ms',
  '--dt-timings-slow-default': '400ms',
  '--dt-timings-slow-moderate': '600ms',
  '--dt-timings-slow-gentle': '800ms',
  '--dt-timings-slowest-default': '1000ms',
  '--dt-timings-slowest-moderate': '1200ms',
  '--dt-timings-slowest-gentle': '1500ms',
};
export default customPropertiesUnified;
